import { Navigate, useParams } from "react-router-dom";

/** Redirects legacy /playground and /playground/:session_id bookmarks to /studio equivalents. */
const PlaygroundRedirect = () => {
  const { session_id } = useParams<{ session_id?: string }>();
  return <Navigate to={session_id ? `/studio/${session_id}` : "/studio"} replace />;
};

export default PlaygroundRedirect;
